async function loadMoreCollections() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const collectionGridLoadMore = document.querySelector(".collection-list__load-more") ?? document.querySelector('.collection');
    const collectionGrid = document.querySelector('.collection-list') ?? document.querySelector('.product-grid.grid') ?? document.querySelector('#product-grid') ?? document.querySelector(".projects__cards") ?? document.querySelector(".blog-articles");

    const loadMoreBlock = document.querySelector('.load-more__inner');
    const {value: pageUrl} = loadMoreBlock?.querySelector('.url_page');
    const {value: totalPage} = loadMoreBlock?.querySelector('.total__page');
    const loaderButton = document.querySelector('.load-more__button');

    try {
        collectionGrid?.classList.add('loading');
        collectionGridLoadMore?.classList.add('collection-list__load-more--active');
        const response = await fetch(pageUrl);
        const data = await response.text();

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(data, 'text/html');
        const newSearchGridItems = parsedHTML.querySelectorAll('.template-search__results .product-grid.grid .grid__item');
        const newProductGridItems = parsedHTML.querySelectorAll('#product-grid .grid__item');
        const newCollectionListItems = parsedHTML.querySelectorAll('.collection-list .collection-list__item');
        const newProjectsListItems = parsedHTML.querySelectorAll('.projects__cards .cards__project-card');
        const newArticleListItems = parsedHTML.querySelectorAll('.blog-articles .blog-articles__article');

        const newProductGrid = (newCollectionListItems.length <= 0 && newProductGridItems.length <= 0 && newSearchGridItems.length <= 0 && newArticleListItems.length <= 0) ? newProjectsListItems : ((newCollectionListItems.length <= 0 && newProductGridItems.length <= 0 && newArticleListItems.length <= 0) ? newSearchGridItems : (( newCollectionListItems.length <= 0 && newArticleListItems.length <= 0)? newProductGridItems : (( newCollectionListItems.length <= 0 )? newArticleListItems : newCollectionListItems)));
        if (newProductGrid.length > 0) {
            newProductGrid.forEach((div) => collectionGrid.append(div));

            const newLoadMoreBlock = parsedHTML.querySelector('.load-more__inner');
            const {value: newPageUrl} = newLoadMoreBlock?.querySelector('.url_page');
            const {value: newCurrentPage} = newLoadMoreBlock?.querySelector('.current__page');
            loadMoreBlock.querySelector('.url_page').value = newPageUrl;

            if (newCurrentPage === totalPage) {
                loaderButton.remove();
            }
            if (isSafari) {
                increaseImageResolution();
            }

            ReloadSmartWishlist();
            collectionGridLoadMore?.classList.remove('collection-list__load-more--active');
            collectionGrid?.classList.remove('loading');
        } else {
            throw new Error('No new items found');
        }
    } catch (error) {
        console.error('Error loading more items:', error);
    }

    function increaseImageResolution(){
        let cardMedia = document.querySelectorAll('.card__media img');
        let blogsMedia = document.querySelectorAll('.blog-articles img');
        let projectsMedia = document.querySelectorAll('.projects__cards img');

        let collectionItemsImages = cardMedia.length > 0 ? cardMedia : blogsMedia > 0 ? blogsMedia : projectsMedia;
        collectionItemsImages.forEach((image) => {
            let url = new URL(image.src);
            let widthParam = url.searchParams.get("width");
            if (widthParam !== null) {
                let width = +widthParam + 1;
                url.searchParams.set("width", width.toString());
                image.src = url;
            }
        });
    }
}